module.exports = __webpack_public_path__ + "img/EditorialDerVergesseneUrsprungThumbnail-400.552a9eb1.jpg";